import { useState } from "react";

import UseAuth from "Hooks/UseAuth";

import Button from "Components/Global/Buttons";
import GetIcon from "Components/Global/Icons";

import FileUpload from "../FileUpload";
import * as S from "./styles";

import { useTheme } from "styled-components";

const Files = ({ projectId, reload, files, documents }) => {
  const theme = useTheme();
  const { parsedJWT } = UseAuth();

  const [openModal, setOpenModal] = useState(false);
  const [documentId, setDocumentId] = useState(null);
  const [documentName, setDocumentName] = useState(null);

  const is_sponsor = parsedJWT?.user?.is_sponsor;

  return (
    <S.Wrapper>
      {openModal ? (
        <FileUpload
          projectId={projectId}
          setOpenModal={setOpenModal}
          documentId={documentId}
          setDocumentId={setDocumentId}
          documentName={documentName}
          setDocumentName={setDocumentName}
          reload={reload}
        />
      ) : null}

      {documents.map((document) => {
        const filtered_sponsor_files = files[document.name]
          ? files[document.name]?.filter((file) =>
              is_sponsor ? file.sponsor_can_see : true,
            )
          : [];

        const show_button = is_sponsor
          ? document.sponsor_only
          : !document.sponsor_only;

        return (
          <S.Document key={document.name}>
            <S.DocumentInfos>
              <h2>{document.display_name}</h2>

              <hr />
            </S.DocumentInfos>

            <S.Files>
              {filtered_sponsor_files.length ? (
                filtered_sponsor_files.map((file) => (
                  <S.File key={file.id}>
                    <S.FileInfos>
                      <h3>{file.name}</h3>
                      <span>{file.file_name}</span>
                    </S.FileInfos>

                    <a
                      href={file.file_src}
                      download
                      rel="noreferrer"
                      target="_blank"
                    >
                      <S.Download>
                        <h1>Download</h1>
                        <GetIcon
                          name="Download"
                          color={theme.colors.neutral.white}
                        />
                      </S.Download>
                    </a>
                  </S.File>
                ))
              ) : (
                <span>Nenhum arquivo encontrado</span>
              )}
            </S.Files>

            {show_button && (
              <S.Buttons>
                <Button
                  text="Adicionar Arquivo"
                  type="button"
                  onClick={() => {
                    setOpenModal(true);
                    setDocumentId(document.id);
                    setDocumentName(document.name);
                  }}
                />
              </S.Buttons>
            )}
          </S.Document>
        );
      })}
    </S.Wrapper>
  );
};

export default Files;
